module.exports = __webpack_public_path__ + "img/eazis-pulse-black-side.5771ce02.png";